import * as React from "react";
interface HomeIconProps {
	[key: string]: any;
}
const HomeIcon: React.FC<HomeIconProps> = (props) => (
	<svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 25.333h4v-6.666c0-.378.128-.695.383-.95a1.29 1.29 0 0 1 .95-.384h5.334c.377 0 .694.128.95.384.255.255.383.572.383.95v6.666h4v-12l-8-6-8 6v12Zm-2.667 0v-12c0-.422.095-.822.284-1.2.188-.378.45-.689.783-.933l8-6a2.57 2.57 0 0 1 1.6-.534c.6 0 1.133.178 1.6.534l8 6c.333.244.594.555.783.933.19.378.284.778.284 1.2v12c0 .734-.262 1.361-.784 1.884A2.568 2.568 0 0 1 24 28h-5.333a1.29 1.29 0 0 1-.95-.384 1.29 1.29 0 0 1-.384-.95V20h-2.666v6.666c0 .378-.128.695-.384.95a1.29 1.29 0 0 1-.95.384H8a2.568 2.568 0 0 1-1.883-.784 2.568 2.568 0 0 1-.784-1.883Z"
    />
  </svg>
);
export default HomeIcon;
